<ng-container>
  @if (root() && item().visible !== false) {
    <div class="menu-item__root-text">{{ item().label }}</div>
  } @else if ((!item().routerLink || item().items) && item().visible !== false) {
    <a
      [attr.href]="item().url"
      (click)="itemClick($event)"
      [ngClass]="item().styleClass"
      [attr.target]="item().target"
      tabindex="0"
      pRipple
    >
      @if (item().icon) {
        <i [ngClass]="item().icon" class="menu-item__icon"></i>
      }
      <span class="menu-item__text">{{ item().label }}</span>
      @if (item().items) {
        <i class="pi pi-fw pi-angle-down menu-item__submenu-toggler"></i>
      }
    </a>
  }

  @if (item().routerLink && !item().items && item().visible !== false) {
    <a
      (click)="itemClick($event)"
      [ngClass]="item().styleClass"
      [routerLink]="item().routerLink"
      routerLinkActive="menu-item--active"
      [routerLinkActiveOptions]="
        item().routerLinkActiveOptions || { paths: 'subset', queryParams: 'ignored', matrixParams: 'ignored', fragment: 'ignored' }
      "
      [fragment]="item().fragment"
      [queryParamsHandling]="item().queryParamsHandling"
      [preserveFragment]="item().preserveFragment"
      [skipLocationChange]="item().skipLocationChange"
      [replaceUrl]="item().replaceUrl"
      [state]="item().state"
      [queryParams]="item().queryParams"
      [attr.target]="item().target"
      tabindex="0"
      class="menu-item__link"
      pRipple
    >
      @if (item().icon) {
        <i [ngClass]="item().icon" class="menu-item__icon"></i>
      }
      <span class="menu-item__text">{{ item().label }}</span>
      @if (item().items) {
        <i class="pi pi-fw pi-angle-down menu-item__submenu-toggler"></i>
      }
    </a>
  }

  @if (item().items && item().visible !== false) {
    <ul class="menu-item__submenu" [@children]="submenuAnimation">
      @for (child of item().items; track i; let i = $index) {
        <li igx-menu-item [item]="child" [index]="i" [parentKey]="key" [class]="child['badgeClass']"></li>
      }
    </ul>
  }
</ng-container>
